import React from 'react';
import { reduxForm, Field } from 'redux-form';
import './info-query-form.css';
import CustomTextField from '../common/custom-components/customTextField';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {
  required,
  taxIdMax,
  maxLength10,
  accountMax,
  number,
  taxIdMin,
} from '../../constants/constants';
import CustomCheckBox from '../common/custom-components/customCheckBox';
import InfoMessageBar from '../common/info-message/info-message';

const InfoQueryForm = ({
  errors,
  handleSubmit,
  handleBackForHome,
  back,
  invalid,
  submitting,
  pristine,
}) => {
  console.log('info-query form ', errors);
  return (
    <div className="auth-page" style={{ backgroundColor: '#F7F8F9' }}>
      <div className="container ">
        <div className="row">
          <div className="col-md-6 offset-md-3 col-xs-12">
            <Card boxShadow={3}>
              <CardContent>
                <Typography
                  variant="h6"
                  className="text-xs-center"
                  color="primary"
                  gutterBottom
                  style={{ fontFamily: 'roman', fontSize: 26 }}
                >
                  Retrieve Account
                </Typography>
                <div className="row">
                  {errors && (
                    <InfoMessageBar
                      icColor="errorIc"
                      variant="error"
                      message={errors}
                    />
                  )}
                </div>
                <div className="headerAlign">
                  <Typography display="block" gutterBottom variant="body2">
                    Please enter the information below. Do not enter dashes in
                    the bill account number and ssn/taxId.
                  </Typography>
                </div>
                <form
                  autoComplete="off"
                  name="infoQueryForm"
                  noValidate
                  onSubmit={handleSubmit}
                >
                  <Field
                    className="form-control form-control-lg TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="masterAcc"
                    symbol="Account Number"
                    placeholder="Account Number"
                    required
                    type="text"
                    validate={[required, number, accountMax, maxLength10]}
                    variant="outlined"
                    fullWidth
                  />
                  <Field
                    className="form-control form-control-lg TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="taxId"
                    symbol="TaxId/SSN"
                    placeholder="TaxId/SSN"
                    required
                    type="text"
                    validate={[required, number, taxIdMin, taxIdMax]}
                    variant="outlined"
                    fullWidth
                  />
                  <Field
                    className="form-control form-control-lg TextField-border-radius"
                    component={CustomCheckBox}
                    label={`By entering account retrieval data, you confirm that you have the customer's 
                    authorization for release of information`}
                    name="disclaimer"
                    required
                    type="checkBox"
                    validate={[required]}
                  />

                  <div className="botton1-group">
                    <Button
                      variant="contained"
                      color="primary"
                      className="btn-lg "
                      disabled={invalid || submitting || pristine}
                      type="submit"
                      style={{ borderRadius: 28 }}
                      fullWidth
                    >
                      SUBMIT
                    </Button>
                    {back !== undefined && (
                      <div className="link-pad">
                        <Link
                          component="button"
                          variant="h6"
                          value="back"
                          color="primary"
                          style={{ padding: '15px 50px' }}
                          onClick={handleBackForHome}
                        >
                          BACK
                        </Link>
                      </div>
                    )}
                  </div>
                </form>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

InfoQueryForm.propTypes = {
  errors: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool,
  submitting: PropTypes.bool,
  pristine: PropTypes.bool,
  back: PropTypes.bool,
  handleBackForHome: PropTypes.func,
};

export default reduxForm({
  form: 'infoQueryForm',
  // a unique identifier for this form
})(InfoQueryForm);
